import React, { useState, useEffect } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "../../modal/Modal";
import PainQuestionForm from "./PainQuestionForm/PainQuestionForm";
import ErrorDialog from "../Popups/ErrorDialog";
import { checkAllPainQuestionAnswered } from "./Services/MovementService";
import CONSTANT from "../../../constants/Constant";
import AlertModal from "../AlertModal";

const StaticVideoModal = (props) => {

    const {
        isShow, 
        videoUrl, 
        painQuestionList, 
        setPainQuestionList, 
        exercise, 
        onClickAnalyze, 
        onClickRetakeExercise, 
        isAnalyzingVideo, 
        isAudioPlayEnabled, 
        playGeneralAudio,
        isExamineticsEnabled
    } = props;
    const [doesSubmittedPainQuestionAnswer, setDoesSubmittedPainQuestionAnswer] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const hasExercisePainQuestions = (exercise?.PainQuestions?.length || 0) > 0;

    useEffect(() => {
        if(doesSubmittedPainQuestionAnswer) {
            setDoesSubmittedPainQuestionAnswer(false);
            clearErrorMsg();
        }

        // Auto-submit only when the selected exercise truly has no pain questions.
        // painQuestionList can be temporarily empty during state sync right after opening the modal.
        let timeoutId;
        if(
            isShow.current &&
            painQuestionList &&
            painQuestionList.length === 0 &&
            !hasExercisePainQuestions &&
            !isExamineticsEnabled
        ) {
            timeoutId = setTimeout(() => {
                onClickAnalyzeHandler();
            }, 1000);
        }

        return () => {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
        };
        // if(isAudioPlayEnabled && isShow.current && painQuestionList.length > 0) {
        //     playGeneralAudio && playGeneralAudio(playGeneralAudio(CONSTANT.GENERAL_AUDIOS_KEY_TEXT.ANSWER_PAIN_QUESTION))
        // }
    }, [isShow.current, painQuestionList, hasExercisePainQuestions, isExamineticsEnabled]);

    const clearErrorMsg = () => {
        setErrorMsg("");
    }

    const onClickAnalyzeHandler = () => {
        onClickAnalyze(painQuestionList);
        setDoesSubmittedPainQuestionAnswer(true);
        
        const areAllPainQuesAnswered = checkAllPainQuestionAnswered(painQuestionList);
        if(!areAllPainQuesAnswered) setErrorMsg("Please answer all pain question.");
    }

    return (
        <Modal isOpen={isShow.current} className="modal-lg pain-question" centered>
            <ModalHeader>
                <div className="color-primary-dark-1">
                    Review Movement Video
                </div>
            </ModalHeader>
            <ModalBody>
                {painQuestionList && painQuestionList.length > 0 && (
                    <PainQuestionForm
                        painQuestionList={painQuestionList}
                        setPainQuestionList={setPainQuestionList}
                        isClickedOnSubmitBtn={doesSubmittedPainQuestionAnswer}
                        onClickAnalyzeHandler={onClickAnalyzeHandler}
                        isAnalyzingVideo={isAnalyzingVideo}
                        realTimeDetectionConstrains={props.realTimeDetectionConstrains}
                    />
                )}
                <div className="row">
                    {/*<video autoPlay controls src={videoUrl} className="w-100"/>*/}
                    <div className="video-wrapper">
                        <video autoPlay controls src={videoUrl} />
                    </div>

                </div>
            </ModalBody>
            <ModalFooter>
                {
                    !isAnalyzingVideo
                        ? (
                            <button className="btn color-white" onClick={onClickAnalyzeHandler}>{isExamineticsEnabled ? "Submit" : "Review & Submit"}</button>
                        )
                        : (
                            <button className="btn color-white" onClick={onClickAnalyzeHandler} disabled={isAnalyzingVideo}>
                                <i className="fa fa-spinner fa-spin"/>&nbsp; {isExamineticsEnabled ? "Submitting..." : "Analyzing..."}
                            </button>
                        )
                }
                <button className="btn retake-button" onClick={() => onClickRetakeExercise(exercise)} disabled={isAnalyzingVideo}>
                    Retake
                </button>
            </ModalFooter>
            {/*<ErrorDialog errorMsg={errorMsg} clearErrorMsg={clearErrorMsg}/>*/}
            <AlertModal
                show={!!errorMsg}
                title="Error"
                type="error"
                onClose={clearErrorMsg}
                onConfirm={clearErrorMsg}
                confirmBtnText="OK"
                showCancel={false}
            >
                {errorMsg}
            </AlertModal>
        </Modal>
    );
}

export default StaticVideoModal;